export function handleShare(social) {
	const location = encodeURIComponent(window.location.href);
	const twitterText = encodeURIComponent('How do you auction an algorithm? Or hang an Instagram portrait? Decoding the world of digital art:');
	let url;

	switch (social) {
		case 'facebook':
			url = `https://www.facebook.com/sharer/sharer.php?u=${location}`;
			break;

		case 'twitter':
			url = `https://twitter.com/share?url=${location}&text=${twitterText}`;
			break;
	}

	open(url, '', 'height=300,width=600');
}

// Hack to only show static footer when all messages are finished animating in
export function toggleStaticFooter(toggle) {
	const staticFooter = document.querySelector('.cnn-static-footer');

	if (staticFooter) {
		staticFooter.style.display = toggle ? 'block' : 'none';
	}
}

// Trigger this event so the sticky position is accurately updated
export function triggerScroll() {
	try {
		window.dispatchEvent(new Event('scroll'));
	} catch (e) {}
}



/** WEBPACK FOOTER **
 ** ./utils.js
 **/